import "./App.css";
import Weather from "./weather";

function App() {
  return (
    <div className="App">
      <div className="container">
        <header>
          <Weather defaultCity="paris" />
        </header>
      </div>
      <footer>
        {" "}
        <a href="https://github.com/alanarv99/weatherreact" target="blank">
          Open-sourced
        </a>{" "}
        by Alana Vazquez
      </footer>
    </div>
  );
}

export default App;
